import Http from '@/services/httpAcademy'

export const getCreatorServiceOfferings = (creatorId) =>
	Http.get(`/admin/creators/${creatorId}/service-offerings`)

export const getCreatorFinancial = (creatorId) =>
	Http.get(`/admin/creators/${creatorId}/financial`)
